import ReactGA from "react-ga4";
import { createAudit } from "../api/madlenAPI";
import { useCallback } from "react";
import { usePostHog } from "posthog-js/react";

type TransportType = "beacon" | "xhr" | "image";

interface AnalyticsEvent {
  category: string;
  action: string;
  label: string;
  value?: number;
  nonInteraction?: boolean;
  transport?: TransportType;
}

export const trackEvent = () => {
  const posthog = usePostHog();

  const track = useCallback(async (event: AnalyticsEvent, ...args: any[]) => {
    ReactGA.event(event, ...args);

    posthog.capture(`${event.category} - ${event.action}`, args);

    try {
      await createAudit({
        actionName: `${event.category} - ${event.action}`,
        extraDetails: {
          ...event,
          ...args,
        },
      });
    } catch (error) {
      console.error("Failed to send audit to backend:", error);
    }
  }, []);

  return { trackEvent: track };
};

export const trackPageView = () => {
  if (window.location.hostname === "localhost") {
    console.log("GA4 PageView: ", window.location.href);
    return;
  }

  const pageViewData = {
    hitType: "pageview",
    page: window.location.href,
    title: window.location.pathname,
  } as const;

  ReactGA.send(pageViewData);

  createAudit({
    actionName: "Page View",
    extraDetails: {
      category: pageViewData.hitType,
      action: pageViewData.page,
      label: pageViewData.title,
    },
  }).catch((error) => {
    console.error("Failed to send page view audit:", error);
  });
};
